import * as React from "react";
import { Component } from "react";
import { Redirect, Route } from "react-router";
import { IAuthState } from "../../model";

export interface IProps {
    component?: React.ComponentClass;
    auth: IAuthState;
    exact?: boolean;
    path?: string;
    render?: (component: any) => any;
}

function renderWithComponent(component: any, auth: any, { ...rest }): any {
    /*
     React Router's render method requires use of lambda in jsx.
     Something we normally should avoid, as it causes unnecessary re-renders.
    */
    return (
        <Route
            {...rest}
            render={(props) => (
                auth.isLoggedIn ? <Component {...props} /> : <Redirect to={{ pathname: "/" }} />
            )}
        />
    );
}

function renderWithRender(render: any, auth: any, { ...rest }): any {
    /*
     React Router's render method requires use of lambda in jsx.
     Something we normally should avoid, as it causes unnecessary re-renders.
    */
    const result = auth.isLoggedIn ? <Route {...rest} render={render} /> : <Redirect to={{ pathname: "/" }} />;
    return result;
}

export default class RequiresAuth extends React.Component<IProps> {
    public render(): React.ReactNode {
        const {
            component, render, auth, ...rest
        } = this.props;
        return component ? renderWithComponent(component, auth, { ...rest }) : renderWithRender(render, auth, { ...rest });
    }
}
